/**
 * Owner: Masa Bayu
 * File: advanced-motion.ts
 * Date:Time: 2026-09-16 18:50
 * Description: T8-E6 Motion preference — reduced-motion Flip fallback policy.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertT8E6SecurityIntact } from './advanced-security';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
export function upsertMotionPreference(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead Motion preference');
    assertT8E6SecurityIntact();
    assertValidId(input.accountId, 'QXRead motion accountId');
    if (typeof input.reducedMotion !== 'boolean') {
        throw new Error('reducedMotion must be boolean');
    }
    const updatedAt = input.updatedAt ?? new Date().toISOString();
    assertTimestamp(updatedAt, 'QXRead motion updatedAt');
    const motionPreferenceId = input.motionPreferenceId !== undefined ? input.motionPreferenceId : createQxreadId('qxrdmot');
    assertValidId(motionPreferenceId, 'QXRead motionPreferenceId');
    return Object.freeze({
        motionPreferenceId,
        accountId: input.accountId,
        reducedMotion: input.reducedMotion,
        flipFallback: input.reducedMotion ? 'instant' : 'fade',
        updatedAt,
        inventsEntitlement: false,
        executesFlip: false,
    });
}
//# sourceMappingURL=advanced-motion.js.map